(function($) {

  'use strict';

  var TOGGLE_SELECTOR = '.fullscreen-menu-toggle';
  var CLOSE_SELECTOR = '#dw_fullscreen_menu--close';
  var FLYOUT_SELECTOR = '.dw_pb_flyout_menu';
  var ACTIVE_CLASS = 'fullscreen-menu-active';

  $(TOGGLE_SELECTOR).click(function(e) {
    e.preventDefault();
    $(FLYOUT_SELECTOR).addClass(ACTIVE_CLASS);
  });

  $(CLOSE_SELECTOR).click(function(e) {
    e.preventDefault();
    $(FLYOUT_SELECTOR).removeClass(ACTIVE_CLASS);
  });

})(jQuery);
